import { User } from '../store.types';

export type AuthStateModel = typeof authState;

interface AuthState {
  signedInUser: {
    user?: User | undefined;
    accessToken?: string;
    [x: string]: unknown;
  };

  isAuthenticated: boolean;
  accountWasDeleted: boolean;
}

const authState: AuthState = {
  signedInUser: {},
  isAuthenticated: false,
  accountWasDeleted: false,
};

export default authState;
